import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import InfoIcon from '@mui/icons-material/Info'
import { Box, Collapse, Grid, Tooltip, Typography } from '@mui/material'
import _ from 'lodash'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** UTILS | CONSTANTS */
import PromotionsApi from 'api/promotion/promotion.api'
import VoucherApi, { VoucherPaymentFindByCodeProps } from 'api/voucher/voucher.api'
import { colors } from 'constants/theme'
import { getBranch, getClinicInfo } from 'utils/app.utils'

/** COMPONENT */
import { orderPaymentChannels, setPromotion, setSummerySubByKey, setSummerySubTreatmentRightByKey, setSummeryTreatmentRightByKey, setVoucher, summery, summerySub, summerySubTreatmentRight, summeryTreatmentRight, voucher } from 'app/slice/payment.slice'
import IconClinicDisabeld from 'assets/icon/icon-clinic-disabeld'
import IconGiftVoucher from 'assets/icon/icon-gift-voucher'
import IconPromotion from 'assets/icon/icon-promotion'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputTextField from 'component/Input/InputTextField'
import { notiError } from 'component/notifications/notifications'
import { ModalVoucherSelectLot } from 'component/Treatments/PopupManageTreatmentCourse'
import * as UseStyled from 'features/finance/payment/component/popupPayment/UseStyledFormPayment'
import { BoxFormCollapse } from 'features/setting/branch-service-point/branch/style'
import MainButton from 'new-components/buttons/main-button'
import { ChannelBox } from './PaymentChannels'
import PrivilegeList from './PrivilegeList'


type PrivilegeProps = {
    menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
    // disabled: boolean | false
    paymentChannels: any
    handleSelectPaymentChannel: (channel: any) => void
    checkIndex: (key: string) => number
    selectChannels: any
    promotionPayment: any
    voucherPayment: any
    treatment: any
    advance?: boolean
    disableTextFiled: (chanel: number) => boolean
    patientCaseId?: number
    patientId?: number
    overdue?: number
    date?: string
}

function Privilege(props: PrivilegeProps) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [open, setOpen] = useState<boolean>(false)

    // ✅ OPTIMIZED: Memoized constants
    const channelShow = useMemo(() => [7, 8], [])
    const branchId: any = useMemo(() => getBranch(), [])
    const branchInfo = useMemo(() => getClinicInfo(), [])

    const paymentChannelsSelected: any = useSelector(orderPaymentChannels)
    const valSummeryTreatmentRight = useSelector(summeryTreatmentRight)
    const valSummerySubTreatmentRight = useSelector(summerySubTreatmentRight)

    const useVoucher = useSelector(voucher)
    const valSummery = useSelector(summery)
    const valSummerySub = useSelector(summerySub)

    const [checkedVoucher, setCheckedVoucher] = useState<boolean>(false)
    const [searchVoucher, setSearchVoucher] = useState<string>("")
    const [errorSearchVoucher, setErrorSearchVoucher] = useState<string>("")
    const [voucherItem, setVoucherItem] = useState<any>({})
    const [popVoucherSelectLot, setPopVoucherSelectLot] = useState<boolean>(false)
    const [dataPopVoucherSelectLot, setDataPopVoucherSelectLot] = useState<any>({})

    const [disableChannel, setDisableChannel] = useState<any>({})


    useEffect(() => {
        if (props.menu === 'EDIT_PAYMENT' && (props.promotionPayment.length || props.voucherPayment.length)) {
            setOpen(true)
            const voucherPopup = props?.treatment?.orderPaymentChannels?.find((item: any) => item.amountPaid > 0)
            if (voucherPopup?.orderPaymentItems?.length) {
                setCheckedVoucher(true)
                setVoucherItem(props?.voucherPayment[0])
            }
        }
    }, [props?.voucherPayment])

    useEffect(() => {
        const checkUseOPro = []
        const checkUseOther = []
        const checkUseList = []
        setDisableChannel({})
        _.map(paymentChannelsSelected, (c: any, index: number) => {
            if (channelShow.includes(Number(index)) && c === true) checkUseOPro.push(c)
            if (!channelShow.includes(Number(index)) && c === true) checkUseOther.push(c)
            if (c === true) checkUseList.push(index)
        })

        setDisableChannel(checkUseList.length > 0 && !checkUseOPro.length && checkUseOther.length === checkUseList.length && checkUseList.length !== checkUseOPro.length ? {
            cursor: 'not-allowed',
            color: '#BBBBBB',
            backgroundColor: '##EBF2F0',
            pointerEvents: 'none'
        } : {})
    }, [paymentChannelsSelected])


    // ✅ OPTIMIZED: Memoized popup handlers
    const onOpenPopVoucherSelectLot = useCallback((item: any) => {
        setDataPopVoucherSelectLot(item)
        setPopVoucherSelectLot(true)
    }, [])

    const onClerPopVoucherSelectLot = useCallback(() => {
        setDataPopVoucherSelectLot({})
        setPopVoucherSelectLot(false)
    }, [])

    // ✅ OPTIMIZED: Memoized verify summary
    const verifySummary = useCallback((pcId: number, val: number, treatments: any) => {
        let balanceSub: number = val
        _.map(valSummerySub[pcId], (sub: any, index: any) => {
            const total: any = sub?.paidBalance || 0
            let paid: any = 0

            if (Object.values(valSummery).filter((valSum: any) => valSum > 0).length === 0) {
                if (balanceSub >= total) {
                    paid = total
                    balanceSub -= total
                } else {
                    paid = balanceSub
                    balanceSub -= balanceSub
                }
            }

            const objUpdate: any = {
                key: pcId,
                keySub: index,
                value: {
                    ...sub,
                    isCheck: true,
                    isDisabled: paid <= 0,
                    value: pcId === 7 ? 0 : paid
                }
            }
            dispatch(setSummerySubByKey(objUpdate))
        })
    }, [valSummerySub, valSummery, dispatch])

    // ✅ OPTIMIZED: Memoized voucher select handler
    const handleVoucherSelect = useCallback((item?: any) => {
        setSearchVoucher(item?.code || '')
        if (item?.voucherListId) {
            setVoucherItem({ ...dataPopVoucherSelectLot, ...item })
            onClerPopVoucherSelectLot()

            const foreignKey = 7
            const id = item.voucherListId

            if (valSummerySubTreatmentRight[foreignKey]?.[id] && valSummeryTreatmentRight?.[foreignKey]?.[id]) {
                for (const index in valSummerySubTreatmentRight[foreignKey][id]) {
                    if (Object.prototype.hasOwnProperty.call(valSummerySubTreatmentRight[foreignKey][id], index)) {
                        const sub = valSummerySubTreatmentRight[foreignKey][id][index]
                        dispatch(
                            setSummerySubTreatmentRightByKey({
                                key: foreignKey,
                                keySub: index,
                                patientTreatmentRightId: id,
                                value: {
                                    ...sub,
                                    isCheck: true,
                                }
                            })
                        )
                    }
                }
            }
        } else {
            setVoucherItem({})
            const newOption = props.menu === 'EDIT_PAYMENT'
                ? [...(props.treatment?.treatments?.order?.orderTreatments || []), ...(props.treatment?.treatments?.order?.orderProducts || [])]
                : props.treatment.summeryTreatments
            dispatch(setVoucher({}))
            verifySummary(7, 0, newOption)
        }
    }, [dataPopVoucherSelectLot, onClerPopVoucherSelectLot, valSummerySubTreatmentRight, valSummeryTreatmentRight, props.menu, props.treatment, dispatch, verifySummary])

    // ✅ OPTIMIZED: Memoized error handler
    const handleVoucherError = useCallback((error: any) => {
        if (error?.statusCode === 404) {
            if (error.message === "NOT_FOUND_VOUCHER_CODE") {
                setErrorSearchVoucher(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
            } else {
                notiError(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
            }
        } else {
            notiError(t(`เกิดข้อผิดพลาด`))
        }
    }, [t])

    // ✅ OPTIMIZED: Memoized voucher loader
    const onLoadVoucher = useCallback(async () => {
        if (searchVoucher && searchVoucher !== '') {
            const condition: VoucherPaymentFindByCodeProps = {
                code: searchVoucher,
            }

            if (props.advance) {
                await VoucherApi.findVoucherCode({ ...condition, patientId: props.patientId })
                    .then((res) => handleVoucherSelect(res?.data))
                    .catch((err) => handleVoucherError(err?.response?.data))
            } else if (props.menu === 'RETROSPECTIVE') {
                await PromotionsApi.findPromotionTreatments({
                    branchId: branchId,
                    patientId: Number(props.patientId),
                    items: _.map(props.treatment.summeryTreatments, (item) => ({
                        itemType: item.group || 'OPERATIVE',
                        itemId: item.operativeId || item.itemId,
                        qty: item.qty
                    })),
                    totalPrice: Number(props.overdue),
                    date: props.date,
                    code: searchVoucher,
                }).then((resp) => handleVoucherSelect(resp?.data))
                    .catch((err) => handleVoucherError(err?.response?.data))
            } else {
                await VoucherApi.findVoucherPaymentByCode(props?.patientCaseId || 0, condition)
                    .then((res) => handleVoucherSelect(res?.data))
                    .catch((err) => handleVoucherError(err?.response?.data))
            }
        }
    }, [searchVoucher, props.advance, props.patientId, props.menu, props.treatment, props.overdue, props.date, props.patientCaseId, branchId, handleVoucherError, handleVoucherSelect])

    // ✅ OPTIMIZED: Memoized voucher renderer
    const renderVoucher = useCallback(() => {
        if (voucherItem?.voucherId) {
            return null
        }

        if (props?.voucherPayment?.length) {
            return (
                <Box width={"100%"} padding={'16px 0 0 62px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                    {props.voucherPayment.map((item: any, index: number) => (
                        <Box key={index} display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                            <Box width={'140px'}>
                                {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NAME')}
                            </Box>
                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                    {item?.voucherName}
                                    {item?.detail && (
                                        <span>
                                            <Tooltip title={item.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' } }}>
                                                <InfoIcon />
                                            </Tooltip>
                                        </span>
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        textDecoration: 'underline',
                                        color: colors.themeSecondColor,
                                        cursor: 'pointer',
                                        width: 'fit-content',
                                        paddingLeft: '8px'
                                    }}
                                    onClick={() => onOpenPopVoucherSelectLot(item)}
                                >
                                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_SELECT_INDEX', { index: item?.voucherDetails?.length || 0 })}
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            )
        }

        return (
            <Box width={"100%"} padding={'16px 0 0 62px'}>
                <Box width={"100%"} alignContent={'center'} textAlign={'center'} color={'#808080'}>
                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NONE')}
                </Box>
            </Box>
        )
    }, [voucherItem?.voucherId, props.voucherPayment, t, onOpenPopVoucherSelectLot])

    // ✅ OPTIMIZED: Memoized payment channel change handler
    const oChangePaymentCannel = useCallback((item: any) => {
        if (item.key === 'VOUCHER') {
            const foreignKey = 7

            if (item.isActive) {
                setSearchVoucher('')
                setVoucherItem({})
                dispatch(setVoucher({}))
                const usePromotion = valSummeryTreatmentRight[foreignKey]

                for (const id in usePromotion) {
                    if (Object.prototype.hasOwnProperty.call(usePromotion, id)) {
                        dispatch(setSummeryTreatmentRightByKey({
                            key: foreignKey,
                            patientTreatmentRightId: id,
                            value: { isCheck: false, value: 0, isDisabled: true }
                        }))

                        if (valSummerySubTreatmentRight[foreignKey]?.[id] && valSummeryTreatmentRight?.[foreignKey]?.[id]) {
                            for (const index in valSummerySubTreatmentRight[foreignKey][id]) {
                                if (Object.prototype.hasOwnProperty.call(valSummerySubTreatmentRight[foreignKey][id], index)) {
                                    const sub = valSummerySubTreatmentRight[foreignKey][id][index]
                                    dispatch(
                                        setSummerySubTreatmentRightByKey({
                                            key: foreignKey,
                                            keySub: index,
                                            patientTreatmentRightId: id,
                                            value: {
                                                ...sub,
                                                isCheck: false,
                                                treatmentPrice: sub.treatmentPrice,
                                                isDisabled: true,
                                                paidBalance: sub.treatmentPrice
                                            }
                                        })
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        if (item.key === 'PROMOTION') {
            const foreignKey = 8
            if (item.isActive) {
                dispatch(setPromotion({}))
                const usePromotion = valSummeryTreatmentRight[foreignKey]

                for (const id in usePromotion) {
                    if (Object.prototype.hasOwnProperty.call(usePromotion, id)) {
                        dispatch(setSummeryTreatmentRightByKey({
                            key: foreignKey,
                            patientTreatmentRightId: id,
                            value: { isCheck: false, value: 0, isDisabled: true }
                        }))

                        if (valSummerySubTreatmentRight[foreignKey]?.[id] && valSummeryTreatmentRight?.[foreignKey]?.[id]) {
                            for (const index in valSummerySubTreatmentRight[foreignKey][id]) {
                                if (Object.prototype.hasOwnProperty.call(valSummerySubTreatmentRight[foreignKey][id], index)) {
                                    const treatmentRightByKey = valSummerySubTreatmentRight[foreignKey][id][index]
                                    dispatch(
                                        setSummerySubTreatmentRightByKey({
                                            key: foreignKey,
                                            keySub: index,
                                            patientTreatmentRightId: id,
                                            value: {
                                                ...treatmentRightByKey,
                                                isCheck: false,
                                                value: 0,
                                                treatmentPrice: treatmentRightByKey.treatmentPrice,
                                                isDisabled: true,
                                                paidBalance: treatmentRightByKey.treatmentPrice
                                            }
                                        })
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        props.handleSelectPaymentChannel(item)
    }, [valSummeryTreatmentRight, valSummerySubTreatmentRight, props, dispatch])

    // ✅ OPTIMIZED: Memoized computed values
    const isCrmEnabled = useMemo(() => branchInfo.isUseCrm === '1', [branchInfo.isUseCrm])

    const totalPromotionVoucherCount = useMemo(() =>
        (props.promotionPayment?.length || 0) + (props?.voucherPayment?.length || 0),
        [props.promotionPayment?.length, props.voucherPayment?.length]
    )

    const tooltipTitle = useMemo(() =>
        isCrmEnabled ? '' : t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION_TOOLTIP'),
        [isCrmEnabled, t]
    )

    const collapseBackgroundColor = useMemo(() =>
        isCrmEnabled ? '' : '#d0cece',
        [isCrmEnabled]
    )

    return (
        <>
            <Box padding={'0 16ox'} marginBottom={'8px'} >
                <Tooltip title={tooltipTitle} placement={'top'}>
                    <BoxFormCollapse sx={{ backgroundColor: collapseBackgroundColor }}>
                        {isCrmEnabled ? (
                            <Box fontSize={'18px'} fontWeight={'500'}>
                                {t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION', { index: totalPromotionVoucherCount })}
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', 'img': { width: '24px', height: '24px' } }}>
                                <Box fontSize={'18px'} fontWeight={'500'}>
                                    {t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION_')}
                                </Box>
                                <IconClinicDisabeld />
                            </Box>
                        )}
                        <Box
                            className={`box-icon-expand-more`}
                            sx={{ transform: `rotate(${open ? 180 : 0}deg)`, pointerEvents: isCrmEnabled ? 'auto' : 'none' }}
                            onClick={() => setOpen(!open)}
                        >
                            <ExpandMoreIcon
                                sx={{
                                    backgroundColor: colors.white,
                                    border: `0.5px solid ${colors.textLightGray}`,
                                    borderRadius: '50px',
                                    color: colors.themeMainColor
                                }}
                            />
                        </Box>
                    </BoxFormCollapse>
                </Tooltip>

                <Collapse in={open}  >
                    <Box padding={'16px'}>
                        <Grid container spacing={1} className="mt-0" sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px 0' }}>
                            {props.paymentChannels.map((item: any, index: number) => {
                                if (props.advance && item.key === "PROMOTION") return
                                if (!channelShow.includes(item?.paymentChanel)) return
                                // const item = _.find(props.paymentChannels, { paymentChanel: channel })
                                const key = `${item.key.toLowerCase()}Payment`
                                const newProps: any = { ...props }
                                const itemLength = (newProps?.[key]?.length || 0)
                                return (
                                    <Grid item xs={3} className=""
                                        sx={{
                                            minWidth: 'calc(100% / 3)',
                                            maxWidth: 'calc(100% / 3)',
                                            minHeight: '50px',
                                            maxHeight: '50px',
                                            paddingTop: '0px !important',
                                            display: 'block',
                                        }}
                                        key={index}
                                    >
                                        <ChannelBox
                                            onClick={() => props.menu !== 'EDIT_PAYMENT' && oChangePaymentCannel(item)}
                                            className={`align-items-center px-2 px-sm-0 text-ellipsis ${item.isActive ? 'active' : ''}`}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex start !important',
                                                paddingLeft: '24px !important',
                                                gap: '8px',
                                                width: '100%',
                                                height: '100%',
                                                borderWidth: '2.5px !important',
                                                '.number': {
                                                    paddingLeft: ' 4px !important',
                                                    textAlign: 'left'
                                                },
                                                'svg': {
                                                    height: '29px !important'
                                                },
                                                '.MuiTypography-root': {
                                                    width: 'fit-content !important'
                                                },
                                                ...disableChannel
                                            }}
                                        >
                                            {props.checkIndex(item.key) !== 0 && <p className={'number'}>{props.checkIndex(item.key)}</p>}
                                            <Box sx={{ svg: { minWidth: '30px', height: '50px !important', filter: item.isActive ? '' : 'grayscale(1)', opacity: item.isActive ? '' : '.6' } }}>
                                                {item.key === 'VOUCHER' && <IconGiftVoucher />}
                                                {item.key === 'PROMOTION' && <IconPromotion />}
                                            </Box>

                                            <Tooltip title={t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}_LENGTH`, { index: itemLength })} arrow placement="right">
                                                <Typography className="pl-2 pl-sm-0 pt-sm-1 text-ellipsis channel-name">{t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}_LENGTH`, { index: (itemLength || 0) })}</Typography>
                                            </Tooltip>
                                        </ChannelBox>
                                    </Grid>
                                )
                            }).reverse()
                            }
                        </Grid>
                    </Box>
                </Collapse >
                {
                    props.selectChannels.map((item: any, index: number) => {
                        if (!channelShow.includes(item?.paymentChanel)) return
                        if (item?.paymentChanel === 8) {
                            return (
                                <Box key={index} padding={'16px'}>
                                    <UseStyled.TitlePayment>
                                        {`${index + 1}. `}
                                        {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}`)}
                                    </UseStyled.TitlePayment>
                                    <Box padding={'16px 0 0 0'} fontWeight={500} >
                                        {t('PAYMENT.FORM_PAYMENT.SUM_NET_PROMOTION')}
                                    </Box>
                                    <Box>
                                        {props?.promotionPayment?.map((item: any, index: number) => {
                                            return (
                                                <PrivilegeList
                                                    disableIcon={true}
                                                    type='TreatmentDiscount'
                                                    menu={props.menu}
                                                    paymentChannelId={8}
                                                    patientTreatmentRightId={item?.promotionBranchId}
                                                    treatmentRight={item}
                                                    key={index}
                                                    title={item?.promotionName}
                                                    treatments={props.treatment}
                                                    disableFiled={props.advance ? false : props.disableTextFiled(8)}
                                                    treatmentInfo={item?.detail}
                                                    discountHasExpired={false}
                                                    advance={props.advance}
                                                />
                                            )
                                        })}
                                    </Box>

                                </Box>
                            )
                        }
                        if (item?.paymentChanel === 7) {
                            return (
                                <Box key={index} padding={'16px'}>
                                    <UseStyled.TitlePayment>
                                        {`${index + 1}. `}
                                        {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}`)}
                                    </UseStyled.TitlePayment>
                                    <Box padding={'16px 0 0 0'} fontWeight={500} >
                                        {t('ส่วนลด Gift Voucher')}
                                    </Box>
                                    <Box>
                                        {!voucherItem?.voucherListId &&
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', padding: "16px 14px 0 0" }}>
                                                <Box sx={{ '.MuiCheckbox-root': { padding: '0px !important' } }}>
                                                    <InputCheckbox onChange={() => setCheckedVoucher(!checkedVoucher)} checked={checkedVoucher} />
                                                </Box>
                                                <Box sx={{ width: '100%', '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiFormControl-root': { position: 'relative' }, '.MuiFormHelperText-root': { position: 'absolute', bottom: '-20px' } }}>
                                                    <InputTextField
                                                        label={t('รหัส Gift Voucher')}
                                                        onchange={(event) => {
                                                            setErrorSearchVoucher("")
                                                            setSearchVoucher(event.target.value)
                                                        }}
                                                        value={searchVoucher}
                                                        inputProps={{
                                                            endAdornment: (
                                                                <Box display={'flex'} alignItems={'center'} gap={'8px'}>

                                                                    <FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} />
                                                                </Box>
                                                            ),
                                                        }}
                                                        helperText={errorSearchVoucher}
                                                    />
                                                </Box>
                                                <Box sx={{ minWidth: '100px', button: { width: '100%' } }}>
                                                    <MainButton
                                                        onClick={onLoadVoucher}
                                                        title={t('เช็ครหัส')}
                                                        type={'primary'}
                                                        variant={'outlined'}
                                                    />
                                                </Box>
                                            </Box>
                                        }

                                        <Box >
                                            {renderVoucher()}
                                        </Box>

                                        {voucherItem?.voucherListId &&
                                            <PrivilegeList
                                                disableIcon={true}
                                                type='VOUCHER'
                                                menu={props.menu}
                                                paymentChannelId={7}
                                                patientTreatmentRightId={Number(voucherItem?.voucherListId)}
                                                treatmentRight={voucherItem}
                                                key={0}
                                                title={`${voucherItem?.voucherCode} ${voucherItem?.voucherName}`}
                                                treatments={props.treatment}
                                                disableFiled={props.advance ? false : props.disableTextFiled(7)}
                                                treatmentInfo={voucherItem?.detail}
                                                discountHasExpired={false}
                                                advance={props.advance}

                                                onCallbackDel={(id: number) => {

                                                    handleVoucherSelect()
                                                }}
                                            />
                                        }
                                    </Box>

                                </Box>
                            )
                        }

                    })
                }

            </Box >

            {
                popVoucherSelectLot &&
                <ModalVoucherSelectLot
                    onClose={onClerPopVoucherSelectLot}
                    data={dataPopVoucherSelectLot}
                    handleVoucherSelect={handleVoucherSelect}
                />
            }
        </>
    )
}

// ✅ OPTIMIZED: Memoized component to prevent unnecessary re-renders
export default memo(Privilege)